import ReceptionAppointmentList from "./ReceptionAppointmentList";

export default ReceptionAppointmentList;